import type { Currency } from '@gat-ship/types'

export class CurrencyUtils {
  static isCurrencyAdded(
    currency: Currency,
    libraryCurrencies: readonly Currency[]
  ) {
    return libraryCurrencies.some(
      (libraryCurrency) => libraryCurrency.code === currency.code
    )
  }

  /**
   * Selects the platform currencies eligible to be added to the library:
   * drops historical currencies, drops those already added (via
   * {@link CurrencyUtils.isCurrencyAdded}), marks each `focusable: true`, then —
   * when `searchTerm` is truthy — keeps only those whose `code` or `name`
   * contains it case-insensitively. Pure: returns a fresh array, mutates nothing.
   */
  static selectVisibleCurrencies(
    allPlatformCurrencies: readonly Currency[],
    libraryCurrencies: readonly Currency[],
    searchTerm: string | undefined
  ): (Currency & { focusable: boolean })[] {
    const eligible = allPlatformCurrencies
      .filter((currency) => currency.isHistorical === false)
      .filter(
        (currency) =>
          !CurrencyUtils.isCurrencyAdded(currency, libraryCurrencies)
      )
      .map((currency) => ({ ...currency, focusable: true }))
    if (!searchTerm) {
      return eligible
    }
    const needle = searchTerm.toLowerCase()
    return eligible.filter(
      (currency) =>
        currency.code.toLowerCase().includes(needle) ||
        currency.name.toLowerCase().includes(needle)
    )
  }
}
